(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-collection"] && !Shopify.designMode) return;
  try {
    
  // Minerva folds sections on the phone. The chevron is a real button, so
  // the tap target is the whole heading row and it works from the keyboard.
  document.querySelectorAll('.revopedia__section').forEach((section) => {
    const heading = section.querySelector('.revopedia__heading');
    const fold = section.querySelector('.revopedia__fold');
    if (!heading || !fold) return;
    const toggle = () => {
      const open = section.classList.toggle('is-open');
      fold.setAttribute('aria-label', open ? 'Згорнути розділ' : 'Розгорнути розділ');
    };
    heading.addEventListener('click', (event) => {
      // Only the phone folds; on the desktop the bodies are always shown.
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      event.preventDefault();
      toggle();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    document.addEventListener('keydown', onKeydown);

    let busy = false;

    function root() {
      return document.querySelector('[data-cart]');
    }

    function lineOf(el) {
      return el.closest('[data-key]');
    }

    function onClick(event) {
      const cart = event.target.closest('[data-cart]');
      if (!cart) return;

      const promo = event.target.closest('[data-promo-apply]');
      if (promo) {
        applyPromo(cart);
        return;
      }

      const remove = event.target.closest('[data-remove]');
      const up = event.target.closest('[data-qty-up]');
      const down = event.target.closest('[data-qty-down]');
      if (!remove && !up && !down) return;

      event.preventDefault();
      const line = lineOf(event.target);
      if (!line) return;

      if (remove) {
        change(line.dataset.key, 0);
        return;
      }
      const input = line.querySelector('[data-qty-input]');
      const current = parseInt(input.value, 10) || 0;
      change(line.dataset.key, up ? current + 1 : Math.max(0, current - 1));
    }

    function onChange(event) {
      if (!event.target.matches('[data-cart] [data-qty-input]')) return;
      const line = lineOf(event.target);
      const q = Math.max(0, parseInt(event.target.value, 10) || 0);
      change(line.dataset.key, q);
    }

    function onKeydown(event) {
      if (!event.target.matches('[data-cart] [data-promo-input], [data-cart] [data-qty-input]')) return;
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (event.target.matches('[data-promo-input]')) {
        applyPromo(event.target.closest('[data-cart]'));
      } else {
        event.target.blur();
      }
    }

    /* Shopify's discount cookie route: the code is validated and applied at
       checkout; the redirect brings the visitor straight back to the cart. */
    function applyPromo(cart) {
      const input = cart.querySelector('[data-promo-input]');
      const code = input && input.value.trim();
      if (!code) return;
      const url = cart.dataset.cartUrl || '/cart';
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(url));
    }

    async function change(key, quantity) {
      if (busy) return;
      const el = root();
      if (!el) return;
      busy = true;
      el.classList.add('is-loading');

      const sectionId = el.dataset.sectionId;
      const url = el.dataset.cartUrl || '/cart';

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId, sections_url: url }),
        });
        const state = await res.json();
        const html = state.sections && state.sections[sectionId];
        if (html) {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
          if (fresh) root().replaceWith(fresh);
        }
        document.querySelectorAll('.header__cart-count').forEach((n) => {
          n.textContent = state.item_count;
        });
      } catch (e) {
        window.location.assign(url);
      } finally {
        busy = false;
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cas-sandbox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Mouse-only toy; touch devices never see the section (hidden in CSS).
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const stage = document.querySelector('[data-cas-stage]');
    if (!stage) return;

    const items = [...stage.querySelectorAll('[data-cas-fig]')].map((el) => ({
      el, x: 0, y: 0, vx: 0, vy: 0, drag: null,
    }));

    items.forEach((f) => {
      f.el.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        f.el.setPointerCapture(event.pointerId);
        f.drag = { px: event.clientX, py: event.clientY, t: performance.now() };
        f.vx = 0;
        f.vy = 0;
      });
      f.el.addEventListener('pointermove', (event) => {
        if (!f.drag) return;
        const now = performance.now();
        const dx = event.clientX - f.drag.px;
        const dy = event.clientY - f.drag.py;
        f.x += dx;
        f.y += dy;
        const dt = Math.max(1, now - f.drag.t);
        f.vx = (dx / dt) * 16;
        f.vy = (dy / dt) * 16;
        f.drag = { px: event.clientX, py: event.clientY, t: now };
      });
      const drop = () => {
        f.drag = null;
      };
      f.el.addEventListener('pointerup', drop);
      f.el.addEventListener('pointercancel', drop);
    });

    (function loop() {
      items.forEach((f) => {
        if (!f.drag) {
          f.x += f.vx;
          f.y += f.vy;
          f.vx *= 0.96;
          f.vy *= 0.96;
          // Soft bounds around each figure's home spot, with a bounce.
          const LX = 320;
          const LY = 200;
          if (f.x > LX || f.x < -LX) {
            f.vx *= -0.7;
            f.x = Math.max(-LX, Math.min(LX, f.x));
          }
          if (f.y > LY || f.y < -LY) {
            f.vy *= -0.7;
            f.y = Math.max(-LY, Math.min(LY, f.y));
          }
        }
        f.el.style.transform = `translate(${f.x.toFixed(1)}px, ${f.y.toFixed(1)}px)`;
      });
      requestAnimationFrame(loop);
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cas-smear"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const host = document.querySelector('[data-smear-hero]');
    if (!host) return;

    /* ---- Header ink ------------------------------------------------------
       The header floats over this banner with no scrim, so its dark type
       lands on whatever the photo happens to show. Read the luminance of the
       banner directly under each of the header's three clusters and flip the
       ones sitting on a dark area to white. Reading them separately matters
       because they land on different parts of the photo: the wordmark and the
       WTF/CART pair sit at the ends, usually on backdrop, while the menu
       between them crosses the middle, where the model usually is. A slide can
       force the answer through its own setting when the measurement gets it
       wrong. */
    const createInk = () => {
      const header = document.querySelector('.header');
      const stage = host.querySelector('.smear-hero__stage');
      if (!header || !stage) return null;
      const groups = ['.header__nav', '.header__logo', '.header__actions']
        .map((sel) => header.querySelector(sel))
        .filter(Boolean);
      if (groups.length === 0) return null;

      /* The bar is read as one row, so it takes one colour: the clusters are
         measured apart because they sit over different parts of the photo, but
         a white WTF beside a black wordmark just looks broken. The colour
         picked is the one whose *worst* cluster still reads best — on a photo
         that is black at the edges and mid-grey in the middle, black type
         disappears at the edges while white stays legible everywhere, so white
         wins. */
      const SWITCH_MARGIN = 1.15; // the other colour has to be clearly better
      /* Reading pixels back off the GPU stalls the pipeline, so it happens at
         most this often — scrolling asks for it far more eagerly than that. */
      const MIN_GAP_MS = 120;
      /* Heartbeat for a page nobody is touching. */
      const IDLE_GAP_MS = 400;

      let forced = 'auto';
      let measure = null; // (groupBoxes, stageBox) => [luminance | null, ...]
      let pending = false;
      let last = 0;

      const plain = () => groups.forEach((g) => g.classList.remove('is-over-dark'));

      const apply = () => {
        const stageBox = stage.getBoundingClientRect();
        const headerBox = header.getBoundingClientRect();
        // Scrolled past the banner (or it never rendered): page colours.
        if (!measure || stageBox.bottom <= headerBox.top + 1) {
          plain();
          return;
        }
        if (forced !== 'auto') {
          groups.forEach((g) => g.classList.toggle('is-over-dark', forced === 'light'));
          return;
        }
        const lums = measure(groups.map((g) => g.getBoundingClientRect()), stageBox);
        /* sRGB average → relative luminance → WCAG contrast, so the two inks
           are compared the way an eye weighs them rather than by a raw
           midpoint. */
        const contrast = (a, b) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
        let white = Infinity;
        let black = Infinity;
        let measured = false;
        lums.forEach((lum) => {
          if (lum === null) return;
          measured = true;
          const rel = Math.pow(lum, 2.2);
          white = Math.min(white, contrast(rel, 1));
          black = Math.min(black, contrast(rel, 0));
        });
        if (!measured) return;
        // Hysteresis on the switch, not on the reading: a crossfade drifting
        // through the middle greys must not strobe the whole bar.
        const isLight = groups[0].classList.contains('is-over-dark');
        const light = isLight ? white * SWITCH_MARGIN > black : white > black * SWITCH_MARGIN;
        groups.forEach((g) => g.classList.toggle('is-over-dark', light));
      };

      const request = () => {
        pending = true;
      };

      /* Driven from the render loop rather than a scroll listener: the bar has
         to drop back to page colours the moment the banner slides out from
         under it, and that has to hold even where scroll events are not
         delivered (embedded previews do exactly this). Two rects a frame. */
      let off = false;
      let lastY = -1;
      const frame = () => {
        const stageBox = stage.getBoundingClientRect();
        const headerBox = header.getBoundingClientRect();
        if (stageBox.bottom <= headerBox.top + 1) {
          if (!off) {
            off = true;
            plain();
          }
          return;
        }
        off = false;
        // Re-measure when the page moves, and otherwise keep a slow heartbeat:
        // the photo behind the bar also changes on its own — the crossfade, the
        // smear drifting — and a one-shot answer at load would stick.
        const y = window.scrollY;
        if (y !== lastY) {
          lastY = y;
          request();
        } else if (performance.now() - last > IDLE_GAP_MS) {
          request();
        }
      };
      window.addEventListener('resize', request, { passive: true });

      /* Both backends read one strip across the whole bar and then average it
         per cluster, so a measurement costs a single read however many
         clusters there are. */
      const spread = (boxes, stageBox, pixels, stripW, scaleX) =>
        boxes.map((box) => {
          const x0 = Math.max(0, Math.round((box.left - stageBox.left) * scaleX));
          const x1 = Math.min(stripW, Math.round((box.right - stageBox.left) * scaleX));
          if (x1 <= x0) return null;
          const rows = pixels.length / 4 / stripW;
          let sum = 0;
          let n = 0;
          for (let row = 0; row < rows; row += 1) {
            for (let x = x0; x < x1; x += 1) {
              const o = (row * stripW + x) * 4;
              sum += (0.2126 * pixels[o] + 0.7152 * pixels[o + 1] + 0.0722 * pixels[o + 2]) / 255;
              n += 1;
            }
          }
          return n ? sum / n : null;
        });

      /* The canvas is only readable inside the frame that drew it, so the
         measurement rides along at the end of the render loop. */
      const flush = () => {
        if (!pending) return;
        const now = performance.now();
        if (now - last < MIN_GAP_MS) return;
        pending = false;
        last = now;
        apply();
      };

      // The still backend has no render loop of its own to ride along with.
      const selfDrive = () => {
        const loop = () => {
          frame();
          flush();
          requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
      };

      return {
        request,
        frame,
        afterFrame: flush,
        setSlide: (slide) => {
          forced = (slide && slide.ink) || 'auto';
          last = 0; // a new photo answers now, not after the throttle
          request();
        },
        attachCanvas: (gl, canvas, dprOf) => {
          /* Eight rows through the middle of the bar. Measured against these
             photos, widening this to the full height of the type — or to the
             whole bar — moved the readings by under a hundredth, so the extra
             readback would buy nothing. */
          const BAND = 8;
          let buf = new Uint8Array(0);
          measure = (boxes, stageBox) => {
            const dpr = dprOf();
            const headerBox = header.getBoundingClientRect();
            const band = BAND;
            const mid = (headerBox.top + headerBox.height / 2 - stageBox.top) * dpr;
            // WebGL counts rows from the bottom of the drawing buffer.
            const y = Math.round(canvas.height - mid - band / 2);
            const y0 = Math.max(0, Math.min(canvas.height - 1, y));
            const rows = Math.min(band, canvas.height - y0);
            if (rows <= 0) return boxes.map(() => null);
            const need = canvas.width * rows * 4;
            if (buf.length < need) buf = new Uint8Array(need);
            const view = buf.subarray(0, need);
            gl.readPixels(0, y0, canvas.width, rows, gl.RGBA, gl.UNSIGNED_BYTE, view);
            return spread(boxes, stageBox, view, canvas.width, dpr);
          };
          request();
        },
        /* No shader running (reduced motion, or no WebGL): the plain photo is
           what shows, so measure that instead — same cover framing the CSS
           uses, sampled through a scratch canvas. */
        fromStill: () => {
          const still = host.querySelector('[data-smear-still]');
          if (!still) return;
          let first = null;
          try {
            first = (JSON.parse(host.dataset.slides || '[]') || [])[0];
          } catch (err) {
            first = null;
          }
          forced = (first && first.ink) || 'auto';
          if (forced !== 'auto') {
            measure = (boxes) => boxes.map(() => null); // apply() only needs a backend
            apply();
            selfDrive();
            return;
          }
          const probe = new Image();
          probe.crossOrigin = 'anonymous';
          probe.addEventListener('load', () => {
            const scratch = document.createElement('canvas');
            scratch.width = 160;
            scratch.height = 4;
            const ctx = scratch.getContext('2d', { willReadFrequently: true });
            if (!ctx) return;
            const posPct = parseFloat(getComputedStyle(host).getPropertyValue('--photo-pos')) || 0;
            measure = (boxes, stageBox) => {
              const iw = probe.naturalWidth;
              const ih = probe.naturalHeight;
              if (!iw || !ih) return boxes.map(() => null);
              // object-fit: cover, centred across, --photo-pos down.
              const scale = Math.max(stageBox.width / iw, stageBox.height / ih);
              const ox = (stageBox.width - iw * scale) / 2;
              const oy = (stageBox.height - ih * scale) * (posPct / 100);
              const headerBox = header.getBoundingClientRect();
              // Same band as the shader path: the middle half of the bar,
              // measured in the photo's own pixels.
              const band = Math.max(2, (headerBox.height * 0.5) / scale);
              const sy = (headerBox.top + headerBox.height / 2 - stageBox.top - oy) / scale;
              const y0 = Math.max(0, Math.min(ih - 2, sy - band / 2));
              // The strip spans the stage, so cluster x maps straight onto it.
              const sx = -ox / scale;
              const sw = stageBox.width / scale;
              const cx = Math.max(0, sx);
              const cw = Math.min(iw - cx, sw - (cx - sx));
              if (cw <= 0) return boxes.map(() => null);
              ctx.clearRect(0, 0, scratch.width, scratch.height);
              ctx.drawImage(probe, cx, y0, cw, Math.min(band, ih - y0), 0, 0, scratch.width, scratch.height);
              const data = ctx.getImageData(0, 0, scratch.width, scratch.height).data;
              return spread(boxes, stageBox, data, scratch.width, scratch.width / stageBox.width);
            };
            apply();
            selfDrive();
          });
          probe.addEventListener('error', () => {});
          probe.src = still.currentSrc || still.src;
        },
      };
    };

    // The banner is hidden on mobile, so there is nothing under the bar there.
    if (window.matchMedia('(max-width: 749px)').matches) return;

    const ink = createInk();
    const canvas = host.querySelector('[data-smear-canvas]');
    const still = host.querySelector('[data-smear-still]');
    const cfg = {
      photo: host.dataset.photo,
      dir: parseFloat(host.dataset.dir) || 1,
      amp: parseFloat(host.dataset.amp) || 0.3,
      start: parseFloat(host.dataset.start) || 0.42,
      rib: parseFloat(host.dataset.rib) || 0.38,
      spd: parseFloat(host.dataset.spd) || 0.22,
      fill: parseFloat(host.dataset.fill),
      pos: parseFloat(host.dataset.pos),
    };

    let slides;
    try {
      slides = JSON.parse(host.dataset.slides || '[]');
    } catch (e) {
      slides = [];
    }
    slides = slides.filter((slide) => slide && slide.src);
    if (slides.length === 0) slides = [{ src: cfg.photo, fill: cfg.fill, pos: cfg.pos }];

    /* Liquid emits every slide at width=2400 because it cannot know the
       viewport. All of them are then fetched up front and held for the life of
       the page, so a phone was carrying five 2400px photos it could never show
       — about 77 MB of decoded pixels for a canvas a few hundred wide. Ask the
       CDN for what this screen can actually use instead, rounded up to a step
       so the variants stay cacheable. */
    (() => {
      const box = host.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 1.25);
      const need = Math.max(600, Math.min(2400, Math.ceil((box.width * dpr) / 200) * 200));
      slides.forEach((slide) => {
        slide.src = String(slide.src).replace(/([?&]width=)\d+/, '$1' + need);
      });
    })();

    const dots = [...host.querySelectorAll('.smear-hero__dot')];
    let active = 0;
    if (dots.length) dots[0].classList.add('is-current');

    /* The controls do not belong to the shader. Until it is live — and for
       good if it never gets there: WebGL off, a shader that will not compile,
       a photo that will not load, reduced motion — a click simply swaps the
       still photograph. `nav.go` is whichever engine is in charge right now;
       the shader takes it over further down, once it has actually started.
       They used to be wired inside the shader's own success path, so any
       failure there left them dead — which is exactly what Safari showed. */
    const nav = {
      go: (target) => {
        if (target === active || !slides[target]) return;
        active = target;
        const slide = slides[active];
        if (still) {
          if (ink) still.addEventListener('load', () => ink.fromStill(), { once: true });
          still.src = slide.src;
          if (!isNaN(slide.pos)) host.style.setProperty('--photo-pos', `${slide.pos * 100}%`);
        }
        dots.forEach((dot, i) => dot.classList.toggle('is-current', i === active));
      },
    };
    const clockReset = { fn: () => {} }; /* filled in once the shader has a clock */

    host.querySelectorAll('[data-smear-prev], [data-smear-next]').forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.hasAttribute('data-smear-next') ? 1 : -1;
        nav.go((active + step + slides.length) % slides.length);
        clockReset.fn();
      });
    });

    host.querySelectorAll('[data-smear-go]').forEach((mark) => {
      mark.addEventListener('click', () => {
        nav.go(parseInt(mark.dataset.smearGo, 10) || 0);
        clockReset.fn();
      });
    });

    // Reduced motion keeps the plain photo; the controls above still switch it.
    // The theme-editor switch takes the very same path: no WebGL context, no
    // draw loop, no slide clock — just the photo and the arrows.
    if (host.dataset.shader === '0' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      /* No WebGL at all: the plain <img> plays the banner. It has to look like
         the shader did — same fill / position framing per slide, same clock,
         a soft dissolve between photos — just without a draw loop. Reduced
         motion keeps the framing but not the clock. */
      const staticOnly = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const FADE = 350;

      const frameStill = (slide) => {
        if (!still || !still.naturalWidth) return;
        const box = still.parentElement.getBoundingClientRect();
        if (!box.width || !box.height) return;
        const rc = box.width / box.height;
        const rt = still.naturalWidth / still.naturalHeight;
        const fill = slide && !isNaN(slide.fill) ? slide.fill : (isNaN(cfg.fill) ? 1 : cfg.fill);
        const pos = slide && !isNaN(slide.pos) ? slide.pos : (isNaN(cfg.pos) ? 0 : cfg.pos);
        host.style.setProperty('--photo-pos', `${pos * 100}%`);
        const st = still.style;
        if (rc > rt) {
          // Wide strip: fill 0 = whole photo height fits (centred, backdrop
          // either side), fill 1 = edge to edge. pos picks the vertical slice.
          const sc = 1 + (rc / rt - 1) * fill;
          st.objectFit = 'fill';
          st.inset = 'auto';
          st.height = `${sc * 100}%`;
          st.width = 'auto';
          st.left = '50%';
          st.transform = 'translateX(-50%)';
          st.top = `${-(sc - 1) * pos * 100}%`;
        } else {
          st.objectFit = ''; st.inset = ''; st.height = ''; st.width = '';
          st.left = ''; st.transform = ''; st.top = '';
        }
      };

      const swapTo = (target) => {
        if (target === active || !slides[target]) return;
        active = target;
        const slide = slides[active];
        dots.forEach((dot, i) => dot.classList.toggle('is-current', i === active));
        if (!still) return;
        const apply = () => {
          frameStill(slide);
          still.style.opacity = '1';
          if (ink) ink.fromStill();
        };
        still.style.transition = `opacity ${FADE}ms ease`;
        still.style.opacity = '0';
        setTimeout(() => {
          still.addEventListener('load', apply, { once: true });
          still.src = slide.src;
          if (still.complete && still.naturalWidth) apply();
        }, FADE);
      };
      nav.go = swapTo;

      const period = Math.max(2, parseFloat(host.dataset.slideSeconds) || 6) * 1000;
      let clock = null;
      const start = () => {
        if (!staticOnly && slides.length > 1) clock = setInterval(() => swapTo((active + 1) % slides.length), period);
      };
      clockReset.fn = () => { clearInterval(clock); start(); };

      const init = () => { frameStill(slides[active]); if (ink) ink.fromStill(); };
      if (still && still.complete && still.naturalWidth) init();
      else if (still) still.addEventListener('load', init, { once: true });
      window.addEventListener('resize', () => frameStill(slides[active]), { passive: true });
      start();
      return;
    }

    const gl = canvas.getContext('webgl', { antialias: false, alpha: false });
    if (!gl) {
      if (ink) ink.fromStill(); // still photo stays — measure that one
      return;
    }

    const VS = `
      attribute vec2 aPos; varying vec2 vUv;
      void main(){ vUv = aPos*0.5+0.5; gl_Position = vec4(aPos,0.0,1.0); }`;

    const FS = `
      precision highp float;
      varying vec2 vUv;
      uniform sampler2D uTex;
      uniform vec2 uRes, uTexRes;
      uniform float uTime, uAmp, uStart, uRib, uSpd, uDir, uFill, uPos;

      float hash(vec2 p){ return fract(sin(dot(p, vec2(127.1,311.7)))*43758.5453123); }
      float noise(vec2 p){
        vec2 i=floor(p), f=fract(p); f=f*f*(3.0-2.0*f);
        return mix(mix(hash(i),hash(i+vec2(1.0,0.0)),f.x),
                   mix(hash(i+vec2(0.0,1.0)),hash(i+vec2(1.0,1.0)),f.x), f.y);
      }
      float fbm(vec2 p){ float v=0.0,a=0.5; for(int i=0;i<4;i++){ v+=a*noise(p); p*=2.03; a*=0.5; } return v; }

      /* Places the photo in the strip. Past its edges the sampler is
         CLAMP_TO_EDGE, so the plain studio backdrop simply continues and the
         smear flows into it rather than hitting a hard border. */
      vec2 cover(vec2 uv){
        float rc = uRes.x/uRes.y, rt = uTexRes.x/uTexRes.y;
        if(rc > rt){
          /* uFill blends between two ways of sizing the photo in a wide strip:
               0 — the whole photo height fits, so nothing is cut, but it only
                   covers part of the width and the rest is extended backdrop;
               1 — the photo fills the width edge to edge (like object-fit:cover).
             It stays centred either way; uPos chooses which slice of the height
             survives when the strip is shorter than the photo. */
          float s = mix(1.0, rc/rt, uFill);      /* photo height ÷ strip height */
          float k = rc/(s*rt);
          float x = (uv.x - 0.5)*k + 0.5;        /* stays centred at any fill */
          /* uPos slides the visible window over the photo: 0 keeps the top edge
             (head safe, trims below), 1 keeps the bottom edge. */
          float y = (1.0 - 1.0/s)*(1.0 - uPos) + uv.y/s;
          return vec2(x, y);
        }
        return vec2(uv.x, (uv.y-0.5)*(rt/rc) + 0.5);
      }

      void main(){
        vec2 uv = vUv;
        /* the smear only builds up toward the empty side of the frame */
        float axis = uDir > 0.0 ? uv.x : 1.0 - uv.x;
        float mask = smoothstep(uStart, 1.0, axis);
        float flow   = fbm(vec2(uv.y*5.0,  uTime*uSpd*0.6));
        float ribbon = fbm(vec2(uv.y*26.0, uTime*uSpd*1.1 + 7.3));
        float amp = uAmp * (0.82 + 0.18*sin(uTime*0.5));
        float a = amp * mask * (0.30 + 1.15*flow);

        vec4 acc = vec4(0.0); float wsum = 0.0;
        for(int i=0;i<14;i++){
          float t = float(i)/13.0;
          float off = a * t;
          vec2 p = uv - vec2(off*uDir, 0.0);
          p.y += (ribbon-0.5) * off * uRib;
          float w = 1.0 - t*0.72;
          acc += texture2D(uTex, cover(p)) * w;
          wsum += w;
        }
        gl_FragColor = acc / wsum;
      }`;

    const compile = (type, src) => {
      const s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
    };
    const vs = compile(gl.VERTEX_SHADER, VS);
    const fs = compile(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return;
    const prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);

    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(prog, 'aPos');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    const U = {};
    ['uTex','uRes','uTexRes','uTime','uAmp','uStart','uRib','uSpd','uDir','uFill','uPos']
      .forEach((n) => { U[n] = gl.getUniformLocation(prog, n); });

    /* One texture for the life of the banner. This used to call createTexture()
       on every slide change and never delete what it replaced, so five 2400px
       photos on a six-second timer orphaned roughly 11 MB of GPU memory a
       minute and never gave it back. Texture objects are not collected the way
       JS objects are: the only way out was a new tab. */
    const tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.uniform1i(U.uTex, 0);

    const upload = (image) => {
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image);
    };

    const load = (src) =>
      new Promise((done, fail) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => done(image);
        image.onerror = fail;
        image.src = src;
        /* a fetch that hangs would otherwise hold `busy` for good and freeze
           the controls on the shader side */
        setTimeout(() => fail(new Error('timeout')), 10000);
      });

    let img = null;

    /* The visitor may already have clicked while this photo was on its way:
       the shader opens on the slide it fetched, then catches up below. */
    const firstIndex = active;
    load(slides[firstIndex].src).then((first) => {
      img = first;
      upload(img);

      /* Only the photo on screen and the one after it are kept. Fetching every
         slide up front and holding all of them for the visit parked ~60 MB of
         decoded pixels for photos nobody had reached yet; a re-fetch later
         comes out of the browser's HTTP cache, so letting go costs nothing
         but a short decode. */
      const rest = new Array(slides.length).fill(null);
      rest[firstIndex] = img;
      const keepNextOnly = () => {
        const nextI = (active + 1) % slides.length;
        rest.forEach((_, i) => { if (i !== active && i !== nextI) rest[i] = null; });
        if (slides.length > 1 && !rest[nextI]) {
          load(slides[nextI].src).then((image) => { rest[nextI] = image; }).catch(() => {});
        }
      };
      keepNextOnly();

      /* Crossfade by fading the canvas out, swapping the texture and its
         framing, then fading back in — the stage behind it is the same grey
         the banner already sits on, so the seam reads as a dissolve rather
         than a cut. One shader, one context, no second canvas. */
      const FADE_MS = 700;
      let busy = false;
      let queued = null; /* the last click made during a fade lands after it */
      const show = (next, image) => {
        busy = true;
        canvas.style.transition = `opacity ${FADE_MS}ms ease`;
        canvas.style.opacity = '0';
        setTimeout(() => {
          active = next;
          img = image;
          upload(img);
          dots.forEach((dot, i) => dot.classList.toggle('is-current', i === active));
          canvas.style.opacity = '1';
          // New photo, new answer for the header — the buffer already holds it.
          if (ink) ink.setSlide(slides[active]);
          keepNextOnly();
          busy = false;
          if (queued !== null) {
            const next = queued;
            queued = null;
            goTo(next, false);
          }
        }, FADE_MS);
      };

      /* One entry point for every jump — the clock, the two arrows, the marks.
         `wait` is the clock's alone: it may skip a slide the background fetch
         has not reached yet and try again next tick, while anything a visitor
         clicked has to land, so it fetches that slide there and then. Nothing
         starts while a fade is still running. */
      const goTo = (target, wait) => {
        if (target === active) return;
        if (busy) {
          if (!wait) queued = target; /* the clock never queues, a person does */
          return;
        }
        if (rest[target]) {
          show(target, rest[target]);
          return;
        }
        if (wait) return;
        busy = true;
        load(slides[target].src)
          .then((image) => {
            rest[target] = image;
            busy = false;
            show(target, image);
          })
          .catch(() => {
            busy = false;
          });
      };

      const advance = (step, wait) =>
        goTo((active + step + slides.length) % slides.length, wait);

      let clock = null;
      const period = Math.max(2, parseFloat(host.dataset.slideSeconds) || 6) * 1000;
      const start = () => {
        if (slides.length > 1) clock = setInterval(() => advance(1, true), period);
      };
      start();

      /* Any click resets the clock, so the next automatic step is a full period
         away rather than landing a moment after the visitor's own. */
      const restart = () => {
        clearInterval(clock);
        start();
      };

      /* The shader is in charge of the controls from here on. If the still
         was switched while the first photo loaded, catch up with a fade. */
      nav.go = (target) => goTo(target, false);
      clockReset.fn = restart;
      if (active !== firstIndex) {
        const want = active;
        active = firstIndex;
        goTo(want, false);
      }

      let dpr = 1;
      const resize = () => {
        /* 1.25, not 1.75: the effect is a blurred flow, so the extra pixels are
           invisible while the fragment shader pays for every one of them. */
        dpr = Math.min(window.devicePixelRatio || 1, 1.25);
        const b = host.querySelector('.smear-hero__stage').getBoundingClientRect();
        canvas.width = Math.max(2, Math.round(b.width * dpr));
        canvas.height = Math.max(2, Math.round(b.height * dpr));
        gl.viewport(0, 0, canvas.width, canvas.height);
      };
      resize();
      if (ink) {
        ink.attachCanvas(gl, canvas, () => dpr);
        ink.setSlide(slides[active]);
      }
      window.addEventListener('resize', resize, { passive: true });

      host.classList.add('is-live');

      let visible = true;
      let looping = false;

      const t0 = performance.now();
      let drawn = false;
      const draw = () => {
        if (ink) ink.frame();
        if (visible) {
          gl.uniform2f(U.uRes, canvas.width, canvas.height);
          gl.uniform2f(U.uTexRes, img.naturalWidth, img.naturalHeight);
          gl.uniform1f(U.uTime, (performance.now() - t0) / 1000);
          gl.uniform1f(U.uAmp, cfg.amp);
          gl.uniform1f(U.uStart, cfg.start);
          gl.uniform1f(U.uRib, cfg.rib);
          gl.uniform1f(U.uSpd, cfg.spd);
          gl.uniform1f(U.uDir, cfg.dir);
          /* Framing follows the slide, not the section, so each photo can sit
             where it needs to. */
          const slide = slides[active];
          const fill = slide && !isNaN(slide.fill) ? slide.fill : cfg.fill;
          const pos = slide && !isNaN(slide.pos) ? slide.pos : cfg.pos;
          gl.uniform1f(U.uFill, isNaN(fill) ? 1.0 : fill);
          gl.uniform1f(U.uPos, isNaN(pos) ? 0.0 : pos);
          gl.drawArrays(gl.TRIANGLES, 0, 3);
          if (!drawn) {
            drawn = true;
            host.classList.add('is-drawn');
          }
          if (ink) ink.afterFrame();
          requestAnimationFrame(draw);
        } else {
          /* Park the loop rather than spin it. It used to keep scheduling
             itself for the rest of the visit and merely skip the draw, so the
             page never went idle once the banner scrolled away. The observer
             wakes it; ink.frame() runs once more here because the bar still
             has to be handed back to page colours. */
          looping = false;
          if (ink) ink.frame();
        }
      };

      const wake = () => {
        if (looping) return;
        looping = true;
        requestAnimationFrame(draw);
      };
      const io = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        if (visible) wake();
        else if (ink) ink.frame();
      }, { threshold: 0.02 });
      io.observe(host);
      wake();
    }).catch(() => {
      /* the first photo never came: the still stays, and so do the controls */
      if (ink) ink.fromStill();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cas-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wall = document.querySelector('[data-cas-wall]');
    if (!wall) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const grid = wall.querySelector('.cas-wall__grid');
    const slices = Array.from(wall.querySelectorAll('.cas-wall__slice'));
    const videos = Array.from(wall.querySelectorAll('[data-wall-video]'));
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    videos.forEach((v) => {
      v.muted = true;
      v.play().catch(() => {});
    });

    // One renderer per video tile: draws the shared video into each slice's
    // canvas window every frame. Because we skip drawing whenever the video
    // isn't holding a frame (loop seek / pause), the last frame stays put —
    // no black flash at the loop point — and all slices stay perfectly synced.
    const renderers = [];
    videos.forEach((video) => {
      const cell = video.closest('.cas-wall__cell');
      const slicesEl = cell.querySelector('.cas-wall__slices');
      const canvases = Array.from(cell.querySelectorAll('.cas-wall__canvas')).map((cv) => ({
        cv,
        ctx: cv.getContext('2d'),
        c: parseInt(cv.dataset.c, 10) || 0,
        r: parseInt(cv.dataset.r, 10) || 0,
      }));
      const sx = parseInt(cell.style.getPropertyValue('--sx'), 10) || 1;
      const sy = parseInt(cell.style.getPropertyValue('--sy'), 10) || 1;
      const resize = () => {
        canvases.forEach((o) => {
          const b = o.cv.getBoundingClientRect();
          o.cv.width = Math.max(1, Math.round(b.width * dpr));
          o.cv.height = Math.max(1, Math.round(b.height * dpr));
        });
      };
      resize();
      renderers.push({ video, cell, slicesEl, canvases, sx, sy, resize });
    });
    window.addEventListener('resize', () => renderers.forEach((r) => r.resize()), { passive: true });

    const drawRenderer = (R) => {
      const v = R.video;
      if (v.readyState < 2) return; // no frame available (e.g. mid loop seek) → keep last
      const vw = v.videoWidth;
      const vh = v.videoHeight;
      if (!vw || !vh) return;
      const blockW = R.cell.clientWidth;
      const blockH = R.cell.clientHeight;
      const gapStr = getComputedStyle(R.slicesEl).columnGap || getComputedStyle(R.slicesEl).gap;
      const gap = parseFloat(gapStr) || 0;
      const cellW = (blockW - (R.sx - 1) * gap) / R.sx;
      const cellH = (blockH - (R.sy - 1) * gap) / R.sy;
      const scale = Math.max(blockW / vw, blockH / vh); // object-fit: cover
      const offX = (blockW - vw * scale) / 2;
      const offY = (blockH - vh * scale) / 2;
      R.canvases.forEach((o) => {
        const subX = o.c * (cellW + gap);
        const subY = o.r * (cellH + gap);
        const srcX = (subX - offX) / scale;
        const srcY = (subY - offY) / scale;
        const srcW = cellW / scale;
        const srcH = cellH / scale;
        try {
          o.ctx.drawImage(v, srcX, srcY, srcW, srcH, 0, 0, o.cv.width, o.cv.height);
        } catch (e) {}
      });
    };

    let running = true;
    const frame = () => {
      if (running) renderers.forEach(drawRenderer);
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
    // Draw at least one frame for reduced-motion (still image) — the loop keeps
    // running but the video is paused below, so it holds a single frame.

    // Occasional soft invert pulse on individual sub-cells (monitors) — the
    // CSS transition eases it in and out instead of snapping.
    if (!REDUCED && wall.dataset.flicker === '1' && slices.length) {
      setInterval(() => {
        const s = slices[Math.floor(Math.random() * slices.length)];
        s.classList.add('is-inv');
        setTimeout(() => s.classList.remove('is-inv'), 300);
      }, 1600);
    }

    if (REDUCED) {
      // Respect reduced motion: let one frame paint, then freeze the clips.
      setTimeout(() => videos.forEach((v) => v.pause()), 400);
    }

    // Pause (and stop drawing) while the banner is off-screen.
    const io = new IntersectionObserver((entries) => {
      running = entries[0].isIntersecting && !REDUCED;
      videos.forEach((v) => {
        if (entries[0].isIntersecting && !REDUCED) v.play().catch(() => {});
        else v.pause();
      });
    }, { threshold: 0.02 });
    io.observe(grid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.header__dropdown[open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.removeAttribute('open');
      }
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('.product__media'));
    if (slides.length < 2) return;

    const prevButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    let index = 0;

    const segments = Array.from(gallery.querySelectorAll('.product__status-seg'));

    /* щойно відвідувач гортнув сам, підказка вже ні до чого */
    let touched = false;

    const show = (nextIndex) => {
      touched = true;
      slides[index].hidden = true;
      index = (nextIndex + slides.length) % slides.length;
      slides[index].hidden = false;
      segments.forEach((seg, i) => seg.classList.toggle('is-on', i === index));
    };

    prevButton?.addEventListener('click', () => show(index - 1));
    nextButton?.addEventListener('click', () => show(index + 1));

    /* Swipe on touch screens. Horizontal intent only: a mostly-vertical
       gesture is page scrolling and must be left alone.

       A drag that starts on a 3D model or a video belongs to that element —
       model-viewer uses horizontal drags to orbit the model, so stealing them
       made the claw impossible to turn on a phone. */
    let touchX = null;
    let touchY = null;
    const ownsGesture = (target) =>
      target instanceof Element && target.closest('model-viewer, video, iframe');

    gallery.addEventListener(
      'touchstart',
      (e) => {
        if (ownsGesture(e.target)) {
          touchX = null;
          return;
        }
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      },
      { passive: true }
    );
    gallery.addEventListener(
      'touchend',
      (e) => {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        const dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          show(index + (dx < 0 ? 1 : -1));
        }
        touchX = null;
        touchY = null;
      },
      { passive: true }
    );

    /* Один раз за завантаження сторінки, коли галерея вперше на екрані. */
    const hint = () => {
      if (touched) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!window.matchMedia('(max-width: 989px)').matches) return;

      const neighbour = slides[1];
      neighbour.classList.add('is-peek');
      gallery.classList.add('is-hinting');

      setTimeout(() => {
        gallery.classList.remove('is-hinting');
        neighbour.classList.remove('is-peek');
      }, 2200);
    };

    const watcher = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          watcher.disconnect();
          setTimeout(hint, 700);
        });
      },
      { threshold: 0.5 }
    );
    watcher.observe(gallery);
  });

  /* 3D models come out of Shopify as a flat light-grey matte. Push the render
     towards the real product: dark oxidised metal, contrasty lighting. */
  document.querySelectorAll('model-viewer').forEach((mv) => {
    mv.setAttribute('tone-mapping', 'aces');
    mv.setAttribute('exposure', '0.85');
    mv.setAttribute('shadow-intensity', '1');
    mv.setAttribute('shadow-softness', '0.7');
    // Slow, continuous idle spin (still draggable by the visitor).
    mv.setAttribute('auto-rotate', '');
    mv.setAttribute('auto-rotate-delay', '0');
    mv.setAttribute('rotation-per-second', '14deg');
    mv.addEventListener('load', () => {
      const model = mv.model;
      if (!model) return;
      model.materials.forEach((mat) => {
        const pbr = mat.pbrMetallicRoughness;
        pbr.setBaseColorFactor([0.3, 0.3, 0.33, 1]); // dark oxidised silver
        pbr.setMetallicFactor(1);
        pbr.setRoughnessFactor(0.5); // brushed / oxidised, not a mirror
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((root) => {
    const dataElement = root.querySelector('[data-variant-data]');
    const idInput = root.querySelector('[data-variant-id]');
    const button = root.querySelector('[data-add-button]');
    const groups = Array.from(root.querySelectorAll('[data-option-group]'));
    if (!dataElement || !idInput || !button || groups.length === 0) return;

    const variants = JSON.parse(dataElement.textContent);
    const priceElement = root.closest('.product')?.querySelector('[data-product-price]');
    const buyNow = root.querySelector('[data-buy-now]');

    const onOptionChange = () => {
      const selected = groups.map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      const match = variants.find((variant) =>
        variant.options.every((option, index) => option === selected[index])
      );

      if (!match) {
        button.disabled = true;
        button.textContent = button.dataset.soldOutText;
        if (buyNow) buyNow.disabled = true;
        return;
      }

      idInput.value = match.id;
      if (priceElement) priceElement.textContent = match.price;
      button.disabled = !match.available;
      button.textContent = match.available ? button.dataset.addText : button.dataset.soldOutText;
      if (buyNow) buyNow.disabled = !match.available;
    };

    groups.forEach((group) => group.addEventListener('change', onOptionChange));
  });

  /* "Купити" (buy now): add the current variant, then jump to checkout. */
  document.querySelectorAll('[data-buy-now]').forEach((buyNow) => {
    const root = buyNow.closest('[data-product-form]');
    if (!root) return;
    const idInput = root.querySelector('[data-variant-id]');
    const qtyInput = root.querySelector('[name="quantity"]');
    const proxy = root.querySelector('[data-checkout-proxy]');

    /* Chekly stamps every control it has taken over with this attribute (their
       spelling). It claims the proxy on init, so the only reason it would still
       be missing is that its async script has not landed yet. */
    const cheklyReady = async () => {
      for (let waited = 0; waited < 600; waited += 50) {
        if (proxy && proxy.getAttribute('chekly-procceded') === 'true') return true;
        await new Promise((resolve) => setTimeout(resolve, 50));
      }
      return false;
    };

    buyNow.addEventListener('click', async () => {
      if (buyNow.disabled) return;
      const id = idInput && idInput.value;
      if (!id) return;
      const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

      buyNow.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: id, quantity: quantity }),
        });
        if (!res.ok) throw new Error('add failed');
        /* Shopify's own checkout has no payment provider attached, so it is the
           fallback only for visitors Chekly refuses to serve (it runs for UA
           only) — everyone else goes through the proxy it has hooked. */
        if (await cheklyReady()) {
          proxy.click();
        } else {
          window.location.assign('/checkout');
        }
      } catch (e) {
        buyNow.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-character"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-talker]').forEach((root) => {
    // Reduced-motion visitors get the static rest state (full text, frame 1).
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const bubble = root.querySelector('.talker__bubble');
    const wps = parseFloat(root.dataset.wps) || 3;
    const charW = parseFloat(getComputedStyle(root).getPropertyValue('--char-w')) || 230;
    const startH = Math.round(charW * 0.4) + 44; // enough to reach the tail/mouth

    // Collapse the bubble to the small starting nub straight away, so the full
    // text never flashes before the reveal begins.
    bubble.style.overflow = 'hidden';
    bubble.style.height = startH + 'px';

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.disconnect();

        // Measure the full height, then animate from the nub up to it.
        bubble.style.height = 'auto';
        const full = bubble.scrollHeight;
        const from = Math.min(startH, full);
        bubble.style.height = from + 'px';

        const words = (bubble.textContent.trim().split(/\s+/).length) || 1;
        // A policy page runs to thousands of words; at talking pace that is a
        // quarter of an hour of growing bubble. Cap it — past the cap the
        // character simply talks faster.
        const durationMs = Math.min(12000, Math.max(2500, (words / wps) * 1000));

        root.classList.add('is-active'); // character starts talking
        const anim = bubble.animate(
          [{ height: from + 'px' }, { height: full + 'px' }],
          { duration: durationMs, easing: 'linear', fill: 'forwards' }
        );
        anim.onfinish = () => {
          bubble.style.height = 'auto';
          bubble.style.overflow = 'visible';
          root.classList.add('is-frozen'); // character freezes on frame 1
        };
      });
    }, { threshold: 0.2 });

    observer.observe(root);
  });

  } catch(e) { console.error(e); }
})();
})();
